import $ from 'jquery';
/* eslint-disable no-unused-vars */
import Scrollify from 'jquery-scrollify';
/* eslint-enable no-unused-vars */

exports.init = (() => {
  const desktop = 1024;

  const init = () => {
    //const elementSelector = '.vhsnapper > .row, body > .footer';
    const elementSelector = '.vhsnapper > .row, .vhsnapper + footer.footer';

    /* eslint-disable */
    // https://projects.lukehaas.me/scrollify/
    const initScrollify = () => {
      //console.log('init scrollify');
      $.scrollify({
        section: elementSelector,
        sectionName: 'section',
        interstitialSection: 'interstitial',
        easing: "easeOutExpo",
        scrollSpeed: 600,
        touchScroll: true,
        before: function(i) {
          //console.log(id);
          const id = i + 1;
          $('nav.waypoint-menu ul li').removeClass('active').find(`a[href="#${id}"]`).closest('li').addClass('active');
        },
        after: function(i) {},
        afterResize: function() {},
        afterRender: function() {}
      });
    };
    /* eslint-enable */

    const initNextWaypointButton = () => {
      const max = $(elementSelector).length - 1;
      let firstId = null;
      $(elementSelector).each((i, el) => {
        //console.log(i, el);
        const id = i + 1;

        if (firstId === null) {
          firstId = i;
        }

        if (id === max) {
          $(el).append(`<a href="#${firstId}" class="first-frame">First Frame</a>`);
        } else {
          $(el).append(`<a href="#${id}" class="next-frame">Next Frame</a>`);
        }
      });

      $(document).on('click', 'a.next-frame, a.first-frame', (e) => {
        e.preventDefault();
        //console.log(e.target);
        const href = (parseInt(e.target.href.split('#')[1]) + 1);
        //console.log(href, $('.waypoint-menu').find(`a[href="${href}"]`));
        $('.waypoint-menu').find(`a[href="#${href}"]`).click();
      });
    };

    const initWaypoints = () => {
      // Build menu
      const nav = $('<nav>', {
        class: 'waypoint-menu',
      });
      const ul = $('<ul>');
      ul.attr('role', 'navigation');
      $(elementSelector).each((i, el) => {
        const id = i + 1;
        $(el).attr('id', `${id}`);
        const li = $('<li>', {
          html: $('<a>', {
            href: `#${id}`,
            html: id,
          }),
          class: i === 0 ? 'active' : '',
        });
        ul.append(li);
      });
      nav.append(ul);
      $('body').append(nav);
      // Set events
      $(document).on('click', '.waypoint-menu li a', (e) => {
        e.preventDefault();
        //console.log(e.target.href);
        const id = e.target.href.split('#')[1];
        //console.log(id);
        $.scrollify.move(`#${id}`);
      });
    };

    initScrollify();
    initWaypoints();
    initNextWaypointButton();
  };

  const width = window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;

  if (width >= desktop) {
    init();
  }

  // window.onresize = function(event) {};
});



// WEBPACK FOOTER //
// ./src/materials/atoms/13-grid/grid.js